var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGroupPeopleSvgBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Group_People_Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.5,373.75H95c-20,0-35,16.12-35,37.5v37.5H85v-37.5c0-7.47,4-12.5,10-12.5H202.5c6,0,10,5,10,12.5v37.5h25v-37.5C237.5,389.87,222.45,373.75,202.5,373.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405,373.75H297.5c-19.95,0-35,16.12-35,37.5v37.5h25v-37.5c0-7.47,4-12.5,10-12.5H405c6,0,10,5,10,12.5v37.5h25v-37.5C440,389.87,425,373.75,405,373.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150,351.25a75,75,0,1,0-75-75A75.09,75.09,0,0,0,150,351.25Zm0-125a50,50,0,1,1-50,50A50.05,50.05,0,0,1,150,226.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275,276.25a75,75,0,1,0,75-75A75.09,75.09,0,0,0,275,276.25Zm75-50a50,50,0,1,1-50,50A50.05,50.05,0,0,1,350,226.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5,126.25a75,75,0,1,0-75,75A75.09,75.09,0,0,0,322.5,126.25Zm-75,50a50,50,0,1,1,50-50A50.06,50.06,0,0,1,247.5,176.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupPeopleSvgBlack);
export default __webpack_public_path__ + "static/media/Icon_Group_People_SVG_Black.101f9bc1f58fba028853c9494a657d24.svg";
export { ForwardRef as ReactComponent };